import queryString from 'query-string';
import {
  AddTipParams,
  IAdjustTip,
  IApiGetTicketsParam,
  IApiModifyTipCashBody,
  IApiUpdateSupplyFeeBody,
  IEditStaffByBillId,
  IParamSummaryCreditCards,
  IPayloadAptConfirm,
  IRefundBody,
  VoidByBillIdParams,
} from './types/api';
import fetch from 'services/request';
import { IAddTicketManualBody, IApiSplitTicketItem } from './types/ticket';

const baseURL = 'api/v1';

export const getTicketsData = (params: IApiGetTicketsParam) => {
  const paramsPasser = queryString.stringify(
    { ...params },
    { arrayFormat: 'bracket' }
  );

  return fetch({
    method: 'get',
    url: `${baseURL}/bill/list-ticket-by-status?${paramsPasser?.replaceAll('[]', '')}`,
  });
};

export const getTicketDetailsData = (id: string) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/bill/transaction-detail-v2/${id}`,
  });
};

export const changeStaffByBillId = (payload: IEditStaffByBillId) => {
  const _body = {
    billId: payload.billId,
    staffIdOld: payload.staffIdOld,
    staffIdNew: payload.staffIdNew,
  };

  return fetch({
    method: 'post',
    url: `${baseURL}/payment/edit-ticket-staff`,
    body: _body,
    pinCode: payload.pinCode,
  });
};
export const refundByBillId = (payload: IRefundBody) => {
  const _body = {
    billId: payload.billId,
    amount: payload.amount,
  };
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/refund-ticket`,
    body: _body,
    pinCode: payload.pinCode,
  });
};

export const voidByBillId = ({ id, reason }: VoidByBillIdParams) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/void-ticket`,
    body: { billId: id, reason }
  });
};

export const addTipByBillId = (body: AddTipParams) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/add-tip-credit-card`,
    body,
  });
};

export const editCashByBillId = (body: IRefundBody) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/edit-cash`,
    body,
  });
};
export const adjustTip = (body: IAdjustTip[]) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/adjust-multiple-tip-card`,
    body,
  });
};
const updateTicketClosed = (body: IPayloadAptConfirm) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/update-ticket-closed',
    body,
    autoToast: true,
  });
};

const removePendingTicket = (billId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/bill/delete-ticket/${billId}`,
    autoToast: true,
  });
};

const deleteClosedTicket = (billId: string, reason: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/delete-closed-ticket',
    autoToast: true,
    body: { billId, reason },
  });
};

const getSummaryCreditCards = (params: IParamSummaryCreditCards) => {
  return fetch({
    method: 'get',
    url: '/api/v1/bill/summary-credit-cards',
    params,
  });
};

const modifyTipCash = (body: IApiModifyTipCashBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/modify-tip-cash',
    body,
  });
};

const splitCloseTicket = (billId: string, body: IApiSplitTicketItem[]) => {
  return fetch({
    method: 'post',
    url: `/api/v1/bill/split-close-ticket/${billId}`,
    body,
  });
};

const addTicketManual = (body: IAddTicketManualBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/add-ticket-manual',
    body,
  });
};

const getSummaryTickets = (params: IApiGetTicketsParam) => {
  const paramsPasser = queryString.stringify(
    { ...params },
    { arrayFormat: 'bracket' }
  );

  return fetch({
    method: 'get',
    url: `/api/v1/bill/summary-tickets?${paramsPasser?.replaceAll('[]', '')}`,
  });
};

const updateSupplyFee = (body: IApiUpdateSupplyFeeBody) => fetch({
  method: 'post',
  url: '/api/v1/bill/update-supply-fee',
  body,
});

const ticketListApis = {
  getTicketsData,
  getTicketDetailsData,
  refundByBillId,
  voidByBillId,
  changeStaffByBillId,
  editCashByBillId,
  adjustTip,
  updateTicketClosed,
  removePendingTicket,
  deleteClosedTicket,
  getSummaryCreditCards,
  modifyTipCash,
  splitCloseTicket,
  addTicketManual,
  getSummaryTickets,
  updateSupplyFee,
};

export default ticketListApis;
